import classNames from 'classnames'

import s from './Title.module.scss'

type PropsType = {
  children: string
  fontWeight?: number
  color?: string
  prefix?: string
  maxWidth?: number
  className?: string
  textAlign?: 'left' | 'center' | 'right'
}

export const Title = ({
  children,
  color = 'black',
  fontWeight = 400,
  textAlign = 'left',
  prefix,
  maxWidth,
  className,
}: PropsType) => {
  const classes = classNames(className, s.title, {})

  return (
    <h1 className={classes} style={{ color, fontWeight, maxWidth, textAlign }}>
      {prefix && <span className={s.prefix}>{prefix}</span>} {children}
    </h1>
  )
}
